import { MCDANIEL_NAME } from "constants/settings.constants";

export interface GeoSettings {
  id?: string;
  surfaceSource: string;
  ipdbSource?: string;
}

export const DEFAULT_GEO_SETTINGS: GeoSettings = {
  id: undefined,
  surfaceSource: MCDANIEL_NAME,
  ipdbSource: undefined
};
